import { render, staticRenderFns } from "./WorkbenchWelcomeModal.vue?vue&type=template&id=13cc16d1&scoped=true&"
import script from "./WorkbenchWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./WorkbenchWelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchWelcomeModal.vue?vue&type=style&index=0&id=13cc16d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc16d1",
  null
  
)

export default component.exports